// @flow
import React, { Component } from 'react';
import { reduxForm, Field } from 'redux-form';
import {
  WizardForm,
  FormTitleH5
} from '../../../../../components/WizardFormStyles';
import Input from '../../../../../components/Input';
import DropdownInput from '../../../../../components/DropdownInput';
import SubmitButton from '../../../../../components/SubmitButton';
import { DefaultIcon } from '../../../../../components/Icon';
import { handleNext } from '../handleSubmit';
import { countryOptions } from '../../../../../utilities/countries';
import {
  requiredField,
  phoneNumber,
  emailValidation
} from '../../../../../utilities/validations';
import { type Currency } from '../../../../../utilities/types';

type Props = {
  error?: string,
  handleSubmit: Function,
  submitting: boolean,
  currencies: Currency[]
};

class CompanyDetails extends Component<Props> {
  render() {
    const currencyOptions = this.props.currencies.reduce(
      (acc, c) => {
        if (c.currency_type === 'fiat' && c.enabled) {
          acc.push({
            text: c.iso4217,
            value: c.iso4217
          });
        }
        return acc;
      },
      [{ text: '', value: '' }]
    );
    return (
      <WizardForm onSubmit={this.props.handleSubmit}>
        <FormTitleH5 hideOnMobile>
          <DefaultIcon name="company" />
          <span>Company Details</span>
        </FormTitleH5>
        {/* The user fields are required for company details on merchant applications through partner portal whereas the user fields are not required on gateway-web merchant application because 
        the merchant would have already filled this out directly themselves on the sign up page.  */}
        <Field
          name="user.first_name"
          label="First Name"
          component={Input}
          validate={requiredField}
        />
        <Field
          name="user.last_name"
          label="Last Name"
          component={Input}
          validate={requiredField}
        />
        <Field
          name="user.email"
          label="Email"
          component={Input}
          validate={[requiredField, emailValidation]}
        />
        <Field
          name="company_detail_attributes.company_name"
          label="Company name"
          component={Input}
          validate={requiredField}
        />
        <Field
          name="company_detail_attributes.dba"
          label="DBA (if applicable)"
          component={Input}
        />
        <Field
          name="company_detail_attributes.phone_number"
          label="Phone"
          component={Input}
          validate={[requiredField, phoneNumber]}
        />
        <Field
          name="company_detail_attributes.address_attributes.address"
          label="Street address"
          component={Input}
          validate={requiredField}
        />
        <Field
          name="company_detail_attributes.address_attributes.city"
          label="City/Town"
          component={Input}
          validate={requiredField}
        />
        <Field
          name="company_detail_attributes.address_attributes.state"
          label="State"
          component={Input}
          validate={requiredField}
        />
        <Field
          name="company_detail_attributes.address_attributes.zip"
          label="Zip/Postal code"
          component={Input}
          validate={requiredField}
        />
        <Field
          name="company_detail_attributes.address_attributes.country_code"
          label="Country"
          component={DropdownInput}
          typeable
          options={countryOptions}
          validate={requiredField}
        />
        <Field
          name="user_currency"
          label="Settlement Currency"
          component={DropdownInput}
          options={currencyOptions}
          validate={requiredField}
        />
        <SubmitButton
          error={this.props.error}
          value="Next"
          disabled={this.props.submitting}
        />
      </WizardForm>
    );
  }
}

export default reduxForm({
  form: 'verification',
  forceUnregisterOnUnmount: true,
  destroyOnUnmount: false,
  onSubmit: handleNext
  // onSubmitSuccess
  // $FlowFixMe
})(CompanyDetails);
